import styled from "styled-components";
import checkLight from "../../../assets/img/icons/checkLight.svg";
import checkDark from "../../../assets/img/icons/checkDark.svg";

export const ProfileFilterWrapper = styled.div`
  background: ${(props) => props.theme.body};
  width: 100%;
  box-shadow: 1px 6px 20px rgba(0, 0, 0, 0.22);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 35px 20px;
  margin-top: 30px;
  @media (max-width: 1299.98px) {
    padding: 10px 20px 20px;
  }
  @media (max-width: 1199.98px) {
    padding: 10px 15px 20px;
  }
  @media (max-width: 991.98px) {
    max-width: 400px;
    margin: 30px auto 0;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`;

export const ProfileFilterRow = styled.div`
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  & h5 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    margin: 0;
    color: ${(props) => props.theme.textColor};
  }
`;

export const CheckBox = styled.div`
  display: inline-block;
  margin-top: 12px;
  > input {
    opacity: 0;
    width: 0;
    height: 0;
    margin: 0;
  }
  > input + label {
    position: relative;
    padding-left: 35px;
    padding-top: 1px;
    cursor: pointer;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 1px;
      width: 20px;
      height: 20px;
      border: 2px solid ${(props) => props.theme.borderColor};
      background: transparent;
      border-radius: 2px;
    }
    &:after {
      content: "";
      background: ${(props) => (props.theme == "light" ? `url(${checkLight})` : `url(${checkDark})`)} no-repeat center;
      width: 20px;
      height: 20px;
      position: absolute;
      top: -3px;
      left: 4px;
      font-size: 26px;
      color: #0088cc;
      transition: all 0.2s;
    }
  }
  > input:not(:checked) + label {
    &:after {
      opacity: 0;
      transform: scale(0);
    }
  }
  > input:disabled:not(:checked) + label {
    &:before {
      box-shadow: none;
      border-color: #bbb;
      background-color: #ddd;
    }
  }
  > input:checked + label {
    color: #0088cc;
    &:before {
      border: 2px solid #0088cc;
    }
    &:after {
      opacity: 1;
      transform: scale(1);
    }
  }
  > input:disabled:checked + label {
    &:after {
      color: #999;
    }
  }
  > input:disabled + label {
    color: #aaa;
  }
  > input:checked:focus + label,
  input:not(:checked):focus + label {
    &:before {
      border: 1px dotted blue;
    }
  }
`;

export const ProfilePriceFilter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  & input {
    width: 28%;
    background: ${(props) => props.theme.body};
    border: 1px solid ${(props) => props.theme.borderColor};
    border-radius: 5px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.textColor};
    outline: none;
    padding: 7px 10px;
  }
  & button {
    width: 35%;
    background: #dadada;
    border-radius: 20px;
    height: 37px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1f1f23;
    border: none;
    outline: none;
    cursor: pointer;
    background-color: #0088cc;
    color: #fff;
    &:disabled {
      opacity: 0.7;
      background: #dadada;
      color: #1f1f23;
    }
  }
`;
